import { WebhookDelivery, WebhookDeliveryState } from '../types/document-metadata';

export interface WebhookStatePresentation {
  label: string;
  /** Material icon; each state has its own shape so it never relies on colour alone. */
  icon: string;
  toneClass: string;
}

const PRESENTATION: Record<WebhookDeliveryState, WebhookStatePresentation> = {
  delivered: { label: 'Delivered', icon: 'cloud_done', toneClass: 'text-ds-success' },
  retrying: { label: 'Retrying', icon: 'cloud_sync', toneClass: 'text-ds-info' },
  failed: { label: 'Failed', icon: 'cloud_off', toneClass: 'text-ds-danger' },
  held: { label: 'Held — awaiting review', icon: 'pause_circle', toneClass: 'text-ds-warning' },
  not_configured: { label: 'No webhook configured', icon: 'link_off', toneClass: 'text-ds-text-muted' }
};

const UNKNOWN: WebhookStatePresentation = { label: 'Unknown', icon: 'help_outline', toneClass: 'text-ds-text-muted' };

export function webhookStatePresentation(state: string | null | undefined): WebhookStatePresentation {
  return (state && PRESENTATION[state as WebhookDeliveryState]) || UNKNOWN;
}

export function webhookTargetSourceLabel(source: WebhookDelivery['targetSource']): string | null {
  switch (source) {
    case 'per-upload':
      return 'Per-upload URL';
    case 'global':
      return 'Global default';
    default:
      return null;
  }
}

function formatTimestamp(value: string | null | undefined): string | null {
  if (!value) return null;
  const time = Date.parse(value);
  return Number.isNaN(time) ? null : new Date(time).toLocaleString();
}

export function webhookTooltip(delivery: WebhookDelivery | null | undefined): string {
  if (!delivery) return '';
  const presentation = webhookStatePresentation(delivery.state);
  const when = formatTimestamp(delivery.lastAttemptAt ?? delivery.updatedAt);
  const detail = delivery.state === 'failed' || delivery.state === 'retrying' ? delivery.error : null;
  return [`Webhook: ${presentation.label}`, when, detail].filter(Boolean).join(' · ');
}
